type SVGProps = React.ComponentProps<"svg">

export function IconCalendarClock(props: SVGProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M2.75879 10.1637L3.62703 15.0877C3.91474 16.7194 5.47072 17.8089 7.1024 17.5212L10.0972 16.9931M2.75879 10.1637L2.58514 9.17888C2.29743 7.5472 3.38694 5.99122 5.01862 5.70351L11.9123 4.48797C13.544 4.20026 15.0999 5.28977 15.3876 6.92145C15.4835 7.46535 15.1204 7.984 14.5765 8.07991L2.75879 10.1637Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16 20C19.3137 20 22 17.3137 22 14C22 10.6863 19.3137 8 16 8C12.6863 8 10 10.6863 10 14C10 17.3137 12.6863 20 16 20Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16 12V14L17.6667 15.6667" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export function IconTasksFilled(props: SVGProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3 7C3 4.79086 4.79086 3 7 3H17C19.2091 3 21 4.79086 21 7V17C21 19.2091 19.2091 21 17 21H7C4.79086 21 3 19.2091 3 17V7ZM11 9.5C11 8.94772 11.4477 8.5 12 8.5H16C16.5523 8.5 17 8.94772 17 9.5C17 10.0523 16.5523 10.5 16 10.5H12C11.4477 10.5 11 10.0523 11 9.5ZM12 13.5C11.4477 13.5 11 13.9477 11 14.5C11 15.0523 11.4477 15.5 12 15.5H16C16.5523 15.5 17 15.0523 17 14.5C17 13.9477 16.5523 13.5 16 13.5H12ZM9.5 9.5C9.5 10.1904 8.94036 10.75 8.25 10.75C7.55964 10.75 7 10.1904 7 9.5C7 8.80964 7.55964 8.25 8.25 8.25C8.94036 8.25 9.5 8.80964 9.5 9.5ZM8.25 15.75C8.94036 15.75 9.5 15.1904 9.5 14.5C9.5 13.8096 8.94036 13.25 8.25 13.25C7.55964 13.25 7 13.8096 7 14.5C7 15.1904 7.55964 15.75 8.25 15.75Z" fill="currentColor"/>
    </svg>
  )
}

export function IconProgress(props: SVGProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/><path d="M18.5 12C18.5 8.41015 15.5899 5.5 12 5.5V12H18.5Z" fill="currentColor"/>
    </svg>
  )
}

export function IconCalendarFilled(props: SVGProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M8 2C8.55228 2 9 2.44772 9 3V4H15V3C15 2.44772 15.4477 2 16 2C16.5523 2 17 2.44772 17 3V4C19.2091 4 21 5.79086 21 8V9H3V8C3 5.79086 4.79086 4 7 4V3C7 2.44772 7.44772 2 8 2Z" fill="currentColor"/><path d="M3 11V17C3 19.2091 4.79086 21 7 21H17C19.2091 21 21 19.2091 21 17V11H3Z" fill="currentColor"/>
    </svg>
  )
}